import cx from "classnames";

import { Magnify } from "components/icons/generated";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Input from "ds/components/Input";

import styles from "./styles.module.css";

type ResourcesSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
};

const ResourcesSearchInput = ({
  value,
  onChange,
  placeholder = "Search resources...",
  fullWidth,
}: ResourcesSearchInputProps) => {
  return (
    <Box className={styles.searchWrapper} fullWidth={fullWidth}>
      <Input
        className={cx(styles.searchInput, { [styles.fullWidth]: fullWidth })}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <Icon className={styles.searchIcon} src={Magnify} />
    </Box>
  );
};

export default ResourcesSearchInput;
